import $ from 'jquery';
import Vue from 'vue';
import { closeModal, convertDateToDdMmYyyy } from '@/function/function.js';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';

import jsPDF from 'jspdf';

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
// import { cca_config } from '@/config'; 

export default {
    name: 'bon-analyse-examen',
    components: {
        VueHtml2pdf,
        EnteteBonEtFacture
    },
    props: ["operation", "ref_no", "bon_date"],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            today_date: this.date_function(),
            b_date: '',
            ref_bon: "",
            filename: '',

            save_loading: false,
            loadingAnalyse: false,
            loadingExamen: false,
            is_savable: true,
            vm_state: open_menu_state,
            is_printable: false,
            idUser: 1,
            operation_saved: null,
            operation_loading: true,

            btn_disable: false,

            coupon: '',
            prix_a_payer: 0,
            prix_final_apayer: 0,
            calc_prix_reduction: 0,
            tot_prix_clinique: 0,

            paid_service_info: [],
            applied_coupon: 0,

            p_assure: [],
            tot_assureur: 0,
            tot_assure: 0,

            is_disabled: false,
            can_see_apply_coupon: true,
            bon_is_loading: true,

            can_pay_with_deposit: false,
            depot_info: {},
            is_depot: false,

            // ------------------------------------
            bon_anl_is_loading: true,
            bon_anl_is_empty: false,
            bon_exm_is_loading: true,
            bon_exm_is_empty: false,
            is_analyse: false,
            is_examen: false,
            can_see_facture: true,

            is_printing: false,

            is_reliquat: true,
            can_apply_reliquat: false,
            espece_is_less: false,
            reliquat_is_greater: false,
            field_is_empty: false,

            paiement: {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
                remise: 0,
            },
        };
    },

    watch: {
        coupon() {
            this.calcReduction()
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return this.$store.getters["patient"];
        },

        patient_est_assure() {
            return this.$store.getters['patient_est_assure'];
        },

        analyses_selected() {
            return this.$store.getters['analyses_selected']
        },
        
        examens_selected() {
            return this.$store.getters['examens_selected']
        },

        action_selected() {
            if (this.analyses_selected.length > 0 && this.examens_selected.length > 0) {
                return 'Analyse - Examen'
            } else if (this.analyses_selected.length > 0) {
                return 'Bon d\'analyse'
            } else if (this.examens_selected.length > 0) {
                return 'Bon d\'examen'
            }
            return ''
        },

        total_analyses() {
            let total = 0;
            this.analyses_selected.forEach(element => {
                total += parseInt(element.prix);
            });
            return total
        },

        // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        total_a_payer() {
            let total = 0
            total = parseInt(this.prix_a_payer)

            return total;
        },
        
        operation_selected() {
            return this.$store.getters["operationStored"]
        },

        bon_analyses() {
            return this.$store.getters["bon_analyses"]
        },

        bon_examens() {
            return this.$store.getters["bon_examens"]
        },

        info_assurance() {
            return this.$store.getters['info_assurance'];
        },

        ref_bon_analyse() {
            return this.$store.getters['ref_bon_analyse'];
        },

        ref_bon_examen() {
            return this.$store.getters['ref_bon_examen'];
        },
    },
    async mounted() {
        /**
         * Determiner si l'option "Appliquer un coupon de réduction peut être affché"
         * 1. Etre une caissiere
         * 2. Il faut que ce soit un patient non assuré
         */
        if (this.activeRole.nom == 'ROLE_CAISSIERE' && this.patient_est_assure == 0) {
            this.can_see_apply_coupon = true
        } else {
            this.can_see_apply_coupon = false
        }

        if (this.operation) {
            await this.$store.dispatch("getAnOperation", this.operation).then(
                (data) => {
                    this.operation_loading = false
                    this.paid_service_info = data

                    if (this.activeRole.nom == 'ROLE_CAISSIERE' && this.patient_est_assure == 0 && (data.comptabilise == '2' || data.comptabilise == '0')) {
                        this.can_see_apply_coupon = true
                    } else {
                        this.can_see_apply_coupon = false
                    }
                }
            )
        }

        // Générer ref bon d'analyse
        this.$store.dispatch('getRefBonAnalyse') 

        // Générer ref bon d'analyse
        this.$store.dispatch('getRefBonExamen')

        await this.$store.commit("SET_BON_EXAMENS", []);
        await this.$store.commit("SET_BON_ANALYSES", []);

        this.$store.dispatch('getPatientInfoAssurance', { patient_id: this.patient.id })


        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.date_function()

        let tm = new Date()
        this.b_date = convertDateToDdMmYyyy.convertDate(new Date(this.bon_date));
        if (this.analyses_selected.length > 0) {
            this.filename = 'Facture Analyse_'+this.patient.nom+'_'+this.patient.prenoms+'_'+tm.getTime()
            this.is_analyse = true
            let bon_data = {
                patient_id: this.patient.id,
                analyses: this.analyses_selected
            }

            this.setBonAnalyse(bon_data)
            
        } else {
            this.bon_anl_is_loading = false
        }

        if (this.examens_selected.length > 0) {
            this.filename = 'Facture Examen_'+this.patient.nom+'_'+this.patient.prenoms+'_'+tm.getTime()
            this.is_examen = true
            let bon_data = {
                patient_id: this.patient.id,
                examens: this.examens_selected
            }

            this.setBonExamen(bon_data)
            
        } else {
            this.bon_exm_is_loading = false
        }

        if (!this.is_analyse && !this.is_examen) {
            this.can_see_facture = false
        }

        this.$store.dispatch("getPatient", this.patient.id).then(() => {
            // Verifie si le patient est assuré
            this.$store.dispatch('checkIfPatientEstAssure', this.patient.id)
        });

        if (this.operation) {
            this.$store.dispatch("getAnOperation", this.operation).then(
                () => {
                    this.operation_loading = false
                }
            )
        }

        
    },
    methods: {
        calcReliquat() {
            if (this.paiement.montant_paye > 0) {
                if (this.paiement.montant_paye > this.prix_final_apayer) {
                    // this.paiement.reliquat = 
                    this.paiement.reliquat_remis = this.paiement.montant_paye - this.prix_final_apayer
                } else {
                    this.paiement.reliquat = 0
                    this.paiement.reliquat_remis = 0
                }
            } else {
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
        },

        calcResteReliquat() {
            this.paiement.reliquat_remis = parseInt(this.paiement.reliquat_remis)
            if (!Number.isInteger(this.paiement.reliquat_remis)) {
                this.paiement.reliquat_remis = ''
                return
            }

            if (this.paiement.reliquat_remis >= 0) {
                let r = this.paiement.montant_paye - this.prix_final_apayer
                if (this.paiement.reliquat_remis <= r) {
                    this.paiement.reliquat = r - this.paiement.reliquat_remis
                } else {
                    this.paiement.reliquat = (this.paiement.montant_paye - this.prix_final_apayer)
                }
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
        },

        postponeReliquat() {
            this.paiement.reliquat_remis = 0
            this.paiement.reliquat = this.paiement.reliquat = (this.paiement.montant_paye - this.prix_final_apayer)
        },

        nextToConfirm(v) {
            this.paiement.montant_paye = parseInt(this.paiement.montant_paye)
            if (!Number.isInteger(this.paiement.montant_paye)) {
                this.field_is_empty = true
                this.paiement.montant_paye = 0
                return
            }

            if (this.paiement.montant_paye < this.prix_final_apayer) {
                this.espece_is_less = true
                return
            }

            let reliquat_du = this.paiement.montant_paye - this.prix_final_apayer
            if (this.paiement.reliquat_remis > reliquat_du) {
                this.reliquat_is_greater = true
                return
            }

            this.paiement.montant_du = this.prix_final_apayer
            this.paiement.user_id = this.user_id
            this.paiement.patient_id = this.patient.id

            this.paiement.compte_id = this.compte_id

            this.is_reliquat = !v
            this.can_apply_reliquat = v
        },

        async setBonAnalyse(bon_data) {
            this.tot_prix_clinique = 0
            this.bon_anl_is_loading = true
            await this.$store.dispatch('getPrixAssurBonAnalyse', bon_data).then(async() => {
                if (this.bon_analyses.length == 0) {
                    this.bon_anl_is_empty = true
                    this.bon_anl_is_loading = false
                } else {
                    this.bon_anl_is_empty = false

                    let tot_part_assure = 0,
                    tot_part_assureur = 0
    
                    this.prix_a_payer = 0
        
                    await this.bon_analyses.forEach(el => {
                        this.p_assure[el.id] = 0
        
                        // Total prix clinique
                        this.tot_prix_clinique += parseInt(el.prix_clinique)
        
                        if (this.patient_est_assure == 1) {
                            this.prix_a_payer += parseInt(el.prix_base_assureur)

                            if (el.prix_base_assureur == 0) {
                                this.is_disabled = true
                            }
                        } else {
                            this.prix_a_payer += parseInt(el.prix_clinique)
                            if (el.prix_clinique == 0) {
                                this.is_disabled = true
                            }
                        }
        
                        if (el.est_exclusion == 0) {
                            if (el.prix_base_assureur > 0) {
                                tot_part_assureur += ( el.prix_base_assureur * this.info_assurance['taux_analyse'] ) 
                                this.p_assure[el.id] = ( ( 1 - this.info_assurance['taux_analyse'] ) * el.prix_base_assureur ) + el.prix_additionnel
                                tot_part_assure += this.p_assure[el.id]
                            } else {
                                tot_part_assureur += 0
                                this.p_assure[el.id] += 0
                                tot_part_assure += 0
                            }
                        } else {
                            tot_part_assureur += 0
                            this.p_assure[el.id] = el.base_assurance
                            tot_part_assure += this.p_assure[el.id]
                        }
                    })
                    this.calc_prix_reduction = this.total_a_payer
        
                    if (this.patient_est_assure == 1) {
                        this.tot_assureur = tot_part_assureur
                        this.tot_assure = tot_part_assure

                        this.prix_final_apayer = tot_part_assure
                    } else {
                        this.prix_final_apayer = this.total_a_payer
                    }

                    this.bon_anl_is_loading = false
                }
                

                
            })
        },

        async setBonExamen(bon_data) {
            this.bon_exm_is_loading = true
            this.tot_prix_clinique = 0
            await this.$store.dispatch('getPrixAssurExamen', bon_data).then(async() => {
                if (this.bon_examens.length == 0) {
                    this.bon_exm_is_empty = true
                    this.bon_exm_is_loading = false
                } else {
                    this.bon_exm_is_empty = false

                    let tot_part_assure = 0,
                    tot_part_assureur = 0
    
                    this.prix_a_payer = 0
        
                    await this.bon_examens.forEach(el => {
                        this.p_assure[el.id] = 0
        
                        // Total prix clinique
                        this.tot_prix_clinique += parseInt(el.prix_clinique)
        
                        if (this.patient_est_assure == 1) {
                            this.prix_a_payer += parseInt(el.prix_base_assureur)

                            if (el.prix_base_assureur == 0) {
                                this.is_disabled = true
                            }
                        } else {
                            this.prix_a_payer += parseInt(el.prix_clinique)
                            if (el.prix_clinique == 0) {
                                this.is_disabled = true
                            }
                        }

                        
        
                        if (el.est_exclusion == 0) {
                            if (el.prix_base_assureur > 0) {
                                tot_part_assureur += ( el.prix_base_assureur * this.info_assurance['taux_examen'] ) 
                                this.p_assure[el.id] = ( ( 1 - this.info_assurance['taux_examen'] ) * el.prix_base_assureur ) + el.prix_additionnel
                                tot_part_assure += this.p_assure[el.id]
                            } else {
                                tot_part_assureur += 0
                                this.p_assure[el.id] += 0
                                tot_part_assure += 0
                            }
                        } else {
                            tot_part_assureur += 0
                            this.p_assure[el.id] = el.base_assurance
                            tot_part_assure += this.p_assure[el.id]
                        }
                    })
                    this.calc_prix_reduction = this.total_a_payer
        
                    if (this.patient_est_assure == 1) {
                        this.tot_assureur = tot_part_assureur
                        this.tot_assure = tot_part_assure

                        this.prix_final_apayer = tot_part_assure
                    } else {
                        this.prix_final_apayer = this.total_a_payer
                    }
                    this.bon_exm_is_loading = false
                }
                
            })
        },

        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        clearAll(selector) {
            $('#' + selector).val('')
        },

        onCoupon() {
            if (this.analyses_selected.length > 0) {
                let bon_data = {
                    patient_id: this.patient.id,
                    analyses: this.analyses_selected
                }
    
                this.setBonAnalyse(bon_data)
            }

            if (this.examens_selected.length > 0) {
                let bon_data = {
                    patient_id: this.patient.id,
                    examens: this.examens_selected
                }
    
                this.setBonExamen(bon_data)
            }
            this.coupon = ''
            
            let confirm = document.getElementById('apply-coupon');

            if (confirm.checked) {
                $('.m-coupon').modal('show')
            } else {
                $('.m-coupon').modal('hide')
                // this.tot_prix_examen()

                // TODO:: Annuler la réduction
                
                this.calcReduction()
                this.applyCoupon()
            }
        },

        calcReduction() {
            if (this.coupon != '' && parseInt(this.coupon) >= 0) {
                this.calc_prix_reduction = parseInt( (1 - parseInt(this.coupon) / 100) * this.prix_a_payer)
            } else {
                this.calc_prix_reduction = this.prix_a_payer
            }
            
        },

        applyCoupon() {
            this.prix_a_payer = this.calc_prix_reduction
            this.tot_prix_clinique = this.calc_prix_reduction
            this.prix_final_apayer = this.calc_prix_reduction

            $('.m-coupon').modal('hide')
        },

        date_function: function() {
            let date = new Date()
                // let expiration_d = new Date()
                // expiration_d.setDate(date.getDate() + 15)

            let today_month = date.getMonth() + 1
                // let expir_month = expiration_d.getMonth() + 1

            this.today_date = date.getDate() + '/' + today_month + '/' + date.getFullYear()
                // this.expiration_date = expiration_d.getDate() + '/' + expir_month + '/' + expiration_d.getFullYear()

            this.ref_bon = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds() + '/' + today_month + '/' + date.getDate()
        },
        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },
        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        submitSaveBon(est_comptabilise) {
            this.save_loading = true
            this.btn_disable = true

            let prix_comptabilise = 0
            let facture_assur = []
            let assur_facture = {}

            if (this.patient_est_assure == 1) {
                prix_comptabilise = this.tot_assure
            } else {
                prix_comptabilise = this.total_a_payer
            }

            let categorie_operation_id = 1
            // COUPON 
            let r_coupon = []
            let coupon_data = {}

            if (prix_comptabilise > 0) {
                let prestation = '',
                    taux_couverture = 0
                if (this.analyses_selected.length > 0) {
                    categorie_operation_id = 2
                    prestation = 'Analyse'
                    taux_couverture = this.info_assurance['taux_analyse']
                }
                if (this.examens_selected.length > 0) {
                    categorie_operation_id = 3
                    prestation = 'Examen'
                    taux_couverture = this.info_assurance['taux_examen']
                }

                // FACTURE REMBOURSEMENT
                if (this.tot_assureur > 0) {
                    assur_facture = {
                        patient_id: this.patient.id,
                        base_assurance: this.prix_a_payer,
                        taux_couverture: taux_couverture,
                        part_assureur: this.tot_assureur,
                        part_assure: prix_comptabilise,
                        prestation: prestation
                    }
    
                    facture_assur.push(assur_facture)
                }

                if (parseInt(this.coupon) > 0) {
                    coupon_data = {
                        user_id: this.user_id,
                        coupon: (this.tot_prix_clinique - this.prix_a_payer),
                        prix_clinique: this.tot_prix_clinique,
                        prestation: this.action_selected,
                        compte_id: this.compte_id
                    }
                    r_coupon.push(coupon_data)
                }
            }

            if (this.operation) { // si cest une ancienne facture, faire une mise ajour
                if (this.paid_service_info.comptabilise == '0') {       //  Le paiement fut différé, on se contente de mettre à jour
                    // let data = {
                    //     operation_id: this.operation
                    // }
                    let to_send = [];
                    to_send.push(
                        { 
                            operation_id: this.operation
                        }
                    )

                    let data = {
                        type_prestation: 'Analyse',
                        prestation: to_send,
                        depot_info: this.depot_info,
                        is_with_deposit: this.can_pay_with_deposit,
                        user_id: this.userCredentials.user.id
                    }

                    this.$store.dispatch("updateExistingOperation", data).then(() => {
                        this.doSuccessMsg('Enregistrement effectué');
                        $('.confirm-bon').modal('hide')
                        this.save_loading = false;

                        this.btn_disable = false
                        this.is_printable = true;
                        this.is_savable = false;
                    })
                } else {  
                    let data = {
                        prix_comptabilise: prix_comptabilise,
                        coupon: r_coupon,
                        operation_id: this.operation,
                        assurance_facture: facture_assur,
                        comptabilise: est_comptabilise,
                        user_id: this.user_id,
                        est_assure: this.patient_est_assure,
                        compte_id: this.compte_id,
                        utilisateur_id: this.patient.id,
                    }

                    if (this.bon_analyses.length > 0) {
                        this.$store.dispatch('savePendingAnalyse', data).then(() => {
                            this.doAfterSuccess(est_comptabilise)
                            this.save_loading = false;
                        })
                    }

                    if (this.examens_selected.length > 0) {
                        this.$store.dispatch('savePendingExamen', data).then(() => {
                            this.doAfterSuccess(est_comptabilise)
                            this.save_loading = false;
                        })
                    }

                }
            } else {
                if (prix_comptabilise > 0) {

                    let operation_data = {
                        libelle: this.action_selected,
                        montant: prix_comptabilise,
                        coupon: r_coupon,
                        type_operation: 1,
                        comptabilise: est_comptabilise,
                        user_id: this.user_id,
                        utilisateur_id: this.patient.id,
                        type_utilisateur: 1,
                        destination: this.compte_id,
                        categorie_operation_id: categorie_operation_id
                    }

                    this.$store.dispatch("storeOperation", operation_data).then((response) => {
                        this.operation_saved = this.$store.getters['operation']
                      
                        let operation = response.id

                        // ######  BON D'EXAMEN   #######
                        if (this.examens_selected.length > 0) {
                            let examen_data = {
                                operation_id: operation,
                                ref_bon_examen: this.ref_bon_examen,
                                idPatient: this.patient.id,
                                liste: this.examens_selected,
                                est_paye: operation_data.comptabilise,
                                coupon: r_coupon,
                                reduction: this.coupon,
                                est_assure: this.patient_est_assure,
                                assurance_facture: facture_assur,
                            };
                            this.$store.dispatch("storeBonExamen", examen_data).then(() => {
                                this.doAfterSuccess(est_comptabilise)
                                this.save_loading = false;
                            });

                            this.paiement.prestation = 'Bon d\'examen'
                            this.paiement.categorie_operation_id = 3
                        }

                        // ########  BON D'ANALYSE  ##########
                        if (this.bon_analyses.length > 0) {
                            let analyse_data = {
                                operation_id: operation,
                                ref_bon_analyse: this.ref_bon_analyse,
                                idPatient: this.patient.id,
                                liste: this.analyses_selected,
                                est_paye: operation_data.comptabilise,
                                coupon: r_coupon,
                                reduction: this.coupon,
                                est_assure: this.patient_est_assure,
                                assurance_facture: facture_assur,
                            };
                            this.$store.dispatch("storeBonAnalyse", analyse_data).then(() => {
                                this.doAfterSuccess(est_comptabilise)
                                this.save_loading = false;
                            });

                            this.paiement.prestation = 'Bon d\'analyse'
                            this.paiement.categorie_operation_id = 2
                        }

                        // Reliquat
                        if (this.can_apply_reliquat) {
                            this.$store.dispatch('storeReliquat', this.paiement) 
                        }
                    })
                }
            }
        },

        

        doAfterSuccess(comptabilise) {
            $('.modal').modal('hide')
            if (comptabilise == 0) {
                this.doSuccessMsg('Le bon a été enregistré. L\'encaissement a été différé');
            } else if (comptabilise == 1) {
                this.doSuccessMsg('Le bon a été enregistré et encaissé');
            } else if (comptabilise == 2) {
                this.doSuccessMsg('Le bon a été enregistré');
            }

            this.save_loading = false;
            this.btn_disable = false
            this.is_printable = true;
            this.is_savable = false;
            // this.$store.commit("SET_EXAMENS_SELECTED", []);
            // this.$store.commit("SET_ANALYSES_SELECTED", []);
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },

        doErrorMsg: function() {
            this.$toasted.show('Veuillez choisir tous les éléments nécessaires pour l\'enregistrement', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        printToPDF() {
            // Create a new jsPDF instance
            const doc = new jsPDF();
      
            // Get the HTML content to be printed
            const html = this.$refs.content.innerHTML;
      
            // Print the HTML content to PDF
            doc.fromHTML(html, 15, 15, {
              'width': 170
            });
      
            // Save the PDF
            doc.save('output.pdf');
        }
    }
}